"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Required Libs

var BrandUtil = {
  getBrandName: function getBrandName(brandTag) {
    switch (brandTag) {
      case 'law':
        return 'laithwaites';
      case 'wpe':
        return 'winepeople';
      case 'vir':
        return 'virgin';
      case 'adc':
        return 'theaustralianwine';
      default:
        return 'laithwaites';
    }
  },
  getBrand: function getBrand() {
    var brandTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'law';
    var brandArr = ['laithwaites', 'virgin', 'theaustralianwine', 'winepeople'];
    var brand = brandArr.filter(function (elem) {
      return location.host.indexOf(elem) > 0;
    });
    return brand[0] || this.getBrandName(brandTag);
  },
  getCountry: function getCountry() {
    if (location.host.indexOf('com.au') > 0) {
      return 'au';
    } else {
      return 'nz';
    }
  },
  content: function content(brand) {
    var data = {};
    var country = this.getCountry();
    if (brand && brand.indexOf('laithwaites') >= 0 && country === 'nz') {
      brand = 'laithwaites_nz';
    } else if (brand && brand.indexOf('laithwaites') >= 0 && country === 'au') {
      brand = 'winepeople';
    }
    switch (brand) {
      case 'virgin':
        {
          data = {
            tag: 'vir',
            name: 'Virgin Wines',
            nameShort: 'Virgin Wines',
            brandKey: 'AUVIRGIN',
            sunbrandKey: 'AUVIRGIN',
            dataAreaId: 'AU',
            sundataAreaId: 'AUS',
            url: 'https://www.virginwines.com.au',
            urlShort: 'virginwines.com.au',
            unlimited: 'Unlimited',
            unlimitedFull: 'Virgin Wines Unlimited',
            itemTrackingUrl: 'https://www.fastway.com.au/tools/track?l=',
            address: 'Attn: Customer Service',
            mailName: 'Virgin Wines Australia',
            favIcon: '',
            poBox: 'P.O Box 665',
            city: 'Strawberry Hills',
            state: 'NSW',
            zip: '2012',
            country: 'AU',
            phone: '1300 712 870',
            phoneRecr: '1300 712 870',
            emailAddress: 'customerservice@virginwines.com.au',
            hours: {
              monToFri: '8am - 5pm AEST',
              sat: '9am - 12.30pm AEST'
            },
            googleAnalytics: {
              merchantId: '7Q68PuXGj4H0Zh86sZgVUmBxYPcc7FkeoG1FHd668AU',
              gtmId: 'GTM-TGXN62'
            },
            legalName: 'Wine People Pty Ltd trading as Virgin Wines. LIQP770016550.',
            social: [{
              name: 'facebook',
              url: 'https://www.facebook.com/VirginWinesAUS'
            }, {
              name: 'twitter',
              url: 'https://twitter.com/virginwinesAUS'
            }, {
              name: 'instagram',
              url: 'https://www.instagram.com/virginwinesaus/'
            }],
            logo: '/images/us/en/brands/logo/vir/vir_responsive_logo.png',
            defaultContiBumpCode: [{
              type: 'mixed',
              type2: 'mix',
              bumpCode: '00064SV'
            }, {
              type: 'red',
              type2: 'red',
              bumpCode: '00067SV'
            }, {
              type: 'white',
              type2: 'wht',
              bumpCode: '00068SV'
            }],
            ULitemCode: '00044SV',
            eGiftCard: '00043VC',
            googleReCaptchaSiteKey: '6LdNNlMpAAAAANRTFGXsTFalce54_g0N1j5nHJU5'
          };
          break;
        }
      case 'theaustralianwine':
        {
          data = {
            tag: 'adc',
            name: 'The Australian Wine',
            brandKey: 'ADC',
            sunbrandKey: 'AUADC',
            dataAreaId: 'AU',
            sundataAreaId: 'AUS',
            url: 'https://www.theaustralianwine.com.au',
            urlShort: 'theaustralianwine.com.au',
            unlimited: 'Unlimited',
            unlimitedFull: 'The Australian Wine Unlimited',
            itemTrackingUrl: 'https://www.fastway.com.au/tools/track?l=',
            address: 'The Australian Wine',
            mailName: 'Member Service',
            favIcon: '',
            poBox: 'PO Box 665',
            city: 'Strawberry Hills',
            state: 'NSW',
            zip: '2012',
            country: 'AU',
            phone: '1300 765 021',
            phoneRecr: '1300 762 174',
            emailAddress: 'customerservice@theaustralianwine.com.au',
            hours: {
              monToFri: '8am - 5pm AEST',
              sat: '9am - 12.30pm AEST'
            },
            googleAnalytics: {
              merchantId: '_fwBaJHzwfd1J5HUeeFeljP9bt8QfML-7m82yI2yM9M',
              gtmId: 'GTM-KFJSNK'
            },
            legalName: 'Wine People Pty Ltd. LIQP770016550.',
            social: [{
              name: 'facebook',
              url: 'https://www.facebook.com/TheAustralianWine'
            }, {
              name: 'instagram',
              url: 'https://www.instagram.com/theaustralianwine/'
            }],
            logo: '/images/au/en/brands/adc/adc_logo.png',
            defaultContiBumpCode: [{
              type: 'mixed',
              type2: 'mix',
              bumpCode: '00056SV'
            }, {
              type: 'red',
              type2: 'red',
              bumpCode: '00057SV'
            }, {
              type: 'white',
              type2: 'wht',
              bumpCode: '00058SV'
            }],
            ULitemCode: '00044SV',
            eGiftCard: '00041VC',
            googleReCaptchaSiteKey: '6LcYN1MpAAAAAIxHxm0240h764dvMjTwm_ITzVRM'
          };
          break;
        }
      case 'winepeople':
        {
          data = {
            tag: 'wpe',
            name: 'Laithwaites',
            brandKey: 'WP',
            sunbrandKey: 'AUWP',
            dataAreaId: 'AU',
            sundataAreaId: 'AUS',
            url: 'https://www.laithwaites.com.au',
            urlShort: 'laithwaites.com.au',
            unlimited: 'Unlimited',
            unlimitedFull: 'Laithwaites Unlimited',
            itemTrackingUrl: 'https://www.fastway.com.au/tools/track?l=',
            address: 'Laithwaites Customer Service',
            mailName: false,
            favIcon: '/images/au/common/logos/favicon.ico',
            poBox: 'PO Box 665',
            city: 'Strawberry Hills',
            state: 'NSW',
            zip: '2012',
            country: 'AU',
            phone: '1300 362 629',
            phoneRecr: '1300 762 832',
            emailAddress: 'customerservice@laithwaites.com.au',
            hours: {
              monToFri: '8am - 5pm AEST',
              sat: '9am - 12.30pm AEST'
            },
            googleAnalytics: {
              merchantId: 'OUplR8O7pY_DEtCIToaZlXpKxPzlP46VWEvfc2wIyEw',
              gtmId: 'GTM-NF3DKN'
            },
            legalName: 'Wine People Pty Ltd. LIQP770016550.',
            social: [{
              name: 'facebook',
              url: 'https://www.facebook.com/LaithwaitesAus'
            }, {
              name: 'instagram',
              url: 'https://www.instagram.com/laithwaitesaus/'
            }],
            logo: '/images/au/common/logos/law_logo.svg',
            defaultContiBumpCode: [{
              type: 'mixed',
              type2: 'mix',
              bumpCode: '00072SV'
            }, {
              type: 'red',
              type2: 'red',
              bumpCode: '00073SV'
            }, {
              type: 'white',
              type2: 'wht',
              bumpCode: '00074SV'
            }],
            ULitemCode: '00044SV',
            eGiftCard: '00042VC',
            googleReCaptchaSiteKey: '6LcjGlIpAAAAAC2pEtZtGf9SmPm8D2S4yx0UJqoA'
          };
          break;
        }
      case 'laithwaites_nz':
        {
          data = {
            tag: 'law',
            name: 'Laithwaites',
            brandKey: 'LW',
            sunbrandKey: 'NZLW',
            dataAreaId: 'NZ',
            sundataAreaId: 'NZL',
            url: 'https://www.laithwaites.co.nz',
            urlShort: 'laithwaites.co.nz',
            unlimited: 'Unlimited',
            unlimitedFull: 'Laithwaites Unlimited',
            itemTrackingUrl: 'https://www.fastway.com.au/tools/track?l=',
            address: 'Laithwaites Customer Service',
            mailName: "Freepost No 246256, Laithwaite's Wine",
            favIcon: '/images/au/common/logos/favicon.ico',
            poBox: 'PO Box 210105',
            city: 'Laurence Stevens Drive',
            state: 'Auckland',
            zip: '2154',
            country: 'NZ',
            phone: '0800 004 612',
            phoneRecr: '0800 004 612',
            emailAddress: 'customerservice@laithwaites.co.nz',
            hours: {
              monToFri: '10am - 7pm (NZST)',
              sat: '11am to 2.30pm (NZST)'
            },
            googleAnalytics: {
              merchantId: 'SiAh9hvOrVCe5z_f2Q3lup-MwZ7XT7tL2IVxL4vLo1Q',
              gtmId: 'GTM-WH2GBDQ'
            },
            legalName: 'Wine People Pty Ltd. (Licence 57701843).',
            social: [{
              name: 'facebook',
              url: 'https://www.facebook.com/LaithwaitesNZ'
            }, {
              name: 'instagram',
              url: 'https://www.instagram.com/laithwaitesnewzealand/'
            }],
            logo: '/images/au/common/logos/law_logo.svg',
            defaultContiBumpCode: [{
              type: 'mixed',
              type2: 'mix',
              bumpCode: '02665SV'
            }, {
              type: 'red',
              type2: 'red',
              bumpCode: '02666SV'
            }, {
              type: 'white',
              type2: 'wht',
              bumpCode: '02667SV'
            }],
            ULitemCodeNorth: '00028SV',
            ULitemCodeSouth: '00029SV',
            eGiftCard: '02698VC',
            googleReCaptchaSiteKey: '6LcbN1MpAAAAALAT7xlrwlmaZ-jvzLwRbaiBLwiN'
          };
          break;
        }
      default:
        data = {};
    }
    return data;
  }
};
var _default = exports["default"] = BrandUtil;